export const MUNDIAL = 1;
export const JUEGOS_OLIMPICOS = 2;
export const SUDAMERICANO = 3;
export const EUROCOPA = 19;
export const MUNDIAL_CLUBES = 100;
export const CHAMPIONS_LEAGUE = 140;
export const EUROPA_LEAGUE = 141;
export const COPA_LIBERTADORES = 150;
export const COPA_SUDAMERICANA = 154;
